import { forwardRef, PropsWithChildren, PropsWithoutRef } from 'react';
import OurText, { OurTextProps } from '../../components/inputs/OurText';

// NOTE: This extra file is necessary to prevent re-renders and losing input focus
const OurPhoneInput = (props: PropsWithoutRef<PropsWithChildren>, ref: OurTextProps['inputRef']) => (
  <OurText {...props} inputRef={ref} />
);

export default forwardRef(OurPhoneInput);
